import ArticlePage from './pages/ArticlePage';
import CloudPage from './pages/CloudPage';
import ContentPage from './pages/ContentPage';
import ContributorAnswers from './components/ContributorAnswers';
import ConversationConfirmPage from './pages/ConversationConfirmPage';
import ConversationPage from './pages/ConversationPage';
import EventForm from './components/EventForm';
import NotFoundPage from './pages/404';
import OfferingForm from './components/OfferingForm';
import OrganisationItemDelete from './components/OrganisationItemDelete';
import OrganisationOverview from './components/OrganisationOverview';
import OrganisationPage from './pages/OrganisationPage';
import ProjectForm from './components/ProjectForm';
import QuestionDetail from './components/QuestionDetail';
import QuestionsOverview from './components/QuestionsOverview';
import QuestionsPage from './pages/QuestionsPage';
import Vue, { h } from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    { path: '/', redirect: 'home' },
    { path: '/home', component: CloudPage, children: [
        { path: ':slug?/:key?', component: QuestionDetail },
    ]},
    { path: '/fragen-antworten', component: QuestionsPage, children: [
        { path: '', component: QuestionsOverview },
        { path: 'autor/:slug', component: ContributorAnswers },
        { path: ':slug', component: QuestionDetail },
    ]},
    { path: '/organisation/:organisationId', component: OrganisationPage, children: [
        { path: '', component: OrganisationOverview },
        { path: 'offering/add', component: OfferingForm },
        { path: 'offering/edit/:offeringId?', component: OfferingForm },
        { path: 'offering/delete/:itemId?', component: OrganisationItemDelete },
        { path: 'project/add', component: ProjectForm },
        { path: 'project/edit/:offeringId?', component: ProjectForm },
        { path: 'project/delete/:itemId?', component: OrganisationItemDelete },
        { path: 'event/add', component: EventForm },
        { path: 'event/edit/:offeringId?', component: EventForm },
        { path: 'event/delete/:itemId?', component: OrganisationItemDelete },
    ]},
    { path: '/beratung/:conversationId', component: ConversationPage },
    { path: '/beratung/bestaetigung/:conversationId', component: ConversationConfirmPage },
    { path: '/artikel/:slug', component: ArticlePage },
    { path: '/page-not-found', component: NotFoundPage },
    { path: '/:pageName', component: ContentPage },
    { path: '*', component: NotFoundPage },
];
  
export default new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(to) {
        if (to.hash) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve({ selector: to.hash });
                }, 10);
            });
        }
        return { x: 0, y: 0 };
    }
});
